export default __webpack_public_path__ + "resources/icons/n212-8009.png";